export const START_TIMER = 'START_TIMER';
export const STOP_TIMER = 'STOP_TIMER';

export const SET_POINTS_CORRECT_ANSWER = 'SET_CORRECT_ANSWER';
export const SET_POINTS_ACCURACY = 'SET_POINTS_ACCURACY';
export const SET_POINTS_TIME = 'SET_POINTS_TIME';

export const SET_CORRECT_ANSWER_COUNTER_DAILY =
  'SET_CORRECT_ANSWER_COUNTER_DAILY'; // add 1 to the counter of correct answers
export const SET_ANSWERED_QUESTIONS = 'SET_ANSWERED_QUESTION'; // add 1 to the counter of answers
export const SET_REMAINING_QUESTIONS = 'SET_REMAINING_QUESTION'; // takes 1 from the questions counter

export const GET_DAILY_QUIZ_QUESTIONS = 'GET_DAILY_QUIZ_QUESTIONS';
export const SET_DAILY_QUIZ_QUESTIONS = 'SET_DAILY_QUIZ_QUESTIONS';

export const SEND_DAILY_QUIZ_ANSWER = 'SEND_DAILY_QUIZ_ANSWER';

export const UPDATE_TIMER = 'UPDATE_TIMER';

export const GET_RESULTS_DAILY_QUIZ = 'GET_RESULTS_DAILY_QUIZ';
export const SET_RESULTS_DAILY_QUIZ = 'SET_RESULTS_DAILY_QUIZ';

export const SET_INITIAL_TIME = 'SET_INITIAL_TIME';

// CHECK STATUS
export const CHECK_DAILY_QUIZ_STATUS = 'daily_quiz/CHECK_DAILY_QUIZ_STATUS';
export const SET_CHECK_DAILY_QUIZ_STATUS_WAITING =
  'daily_quiz/SET_CHECK_DAILY_QUIZ_STATUS_WAITING';
export const CHECK_QUAL_DAILY_QUIZ_STATUS =
  'daily_quiz/CHECK_QUAL_DAILY_QUIZ_STATUS';
export const SET_IS_LOADING_QUAL_DAILY_QUIZ_STATUS =
  'daily_quiz/SET_IS_LOADING_QUAL_DAILY_QUIZ_STATUS';
export const SET_IS_QUAL_DAILY_QUIZ_RUNNING =
  'daily_quiz/SET_IS_QUAL_DAILY_QUIZ_RUNNING';

// LOAD DAILY QUIZ
export const LOAD_DAILY_QUIZ = 'daily_quiz/LOAD_DAILY_QUIZ';

export const LOAD_QUAL_DAILY_QUIZ = 'daily_quiz/LOAD_QUAL_DAILY_QUIZ';

// UPDATE DAILY QUIZ
export const UPDATE_DAYILY_QUIZ = 'daily_quiz/UPDATE_DAYILY_QUIZ';

export const UPDATE_QUAL_DAILY_QUIZ = 'daily_quiz/UPDATE_QUAL_DAILY_QUIZ';

// SUBMIT DAILY QUIZ
export const SUBMIT_DAILY_QUIZ = 'daily_quiz/SUBMIT_DAILY_QUIZ';
export const SUBMIT_QUAL_DAILY_QUIZ = 'daily_quiz/SUBMIT_QUAL_DAILY_QUIZ';
export const SET_SUBMIT_DAILY_QUIZ_WAITING =
  'daily_quiz/SET_SUBMIT_DAILY_QUIZ_WAITING';
export const SET_IS_LOADING_SUBMIT_QUAL_DAILY_QUIZ =
  'daily_quiz/SET_IS_LOADING_SUBMIT_QUAL_DAILY_QUIZ';
export const SET_SUBMIT_DAILY_QUIZ_SUCCESS =
  'daily_quiz/SET_SUBMIT_DAILY_QUIZ_SUCCESS';
export const SET_IS_SUBMIT_QUAL_DAILY_QUIZ_SUCCESSFUL =
  'daily_quiz/SET_IS_SUBMIT_QUAL_DAILY_QUIZ_SUCCESSFUL';

// SETTERS
export const SET_NEXT_QUIZ_IN = 'daily_quiz/SET_NEXT_QUIZ_IN';
export const SET_NEXT_QUAL_DAILY_QUIZ_IN =
  'daily_quiz/SET_NEXT_QUAL_DAILY_QUIZ_IN';
export const SET_QUAL_DAILY_QUIZ_PROGRESS =
  'daily_quiz/SET_QUAL_DAILY_QUIZ_PROGRESS';
export const SET_DAILY_QUIZ_RUNNING = 'daily_quiz/SET_DAILY_QUIZ_RUNNING';
export const SET_LOAD_DAILY_QUIZ_WAITING =
  'daily_quiz/SET_LOAD_DAILY_QUIZ_WAITING';
export const SET_DAILY_QUIZ = 'daily_quiz/SET_DAILY_QUIZ';
export const SET_DAILY_QUIZ_RETAKE = 'daily_quiz/SET_DAILY_QUIZ_RETAKE';
export const SET_QUAL_DAILY_QUIZ = 'daily_quiz/SET_QUAL_DAILY_QUIZ';
export const SET_QUAL_DAILY_QUIZ_RETAKE =
  'daily_quiz/SET_QUAL_DAILY_QUIZ_RETAKE';
export const SET_PROGRESS = 'daily_quiz/SET_PROGRESS';
export const SET_DAILY_TIMEOUT = 'daily_quiz/SET_DAILY_TIMEOUT';
export const SET_QUAL_DAILY_QUIZ_DAILY_TIMEOUT =
  'daily_quiz/SET_QUAL_DAILY_QUIZ_DAILY_TIMEOUT';
